import { ProductFamily } from "@custom-types/products"
import { GridRowId, GridValidRowModel } from "@mui/x-data-grid"
import { GridApiCommunity } from "@mui/x-data-grid/internals"

export const getAvailableFamilies = (
  families: ProductFamily[],
  gridApi: GridApiCommunity,
  rowId: GridRowId,
): { family: ProductFamily; isUsed: boolean }[] => {
  const rows = gridApi.getAllRowIds().map((id) => gridApi.getRowWithUpdatedValues(id, "family"))
  const currentRow = rows.find(({ id }) => id === rowId)
  const usedProductFamilies = getUsedProductFamiliesMap(rows, "family")

  if (!currentRow) return []

  return families.map((family) => {
    const isCurrentOption = currentRow.family === family.key
    const usedProducts = usedProductFamilies[family.key]

    if (!usedProducts || isCurrentOption) return { family, isUsed: false }

    return { family, isUsed: usedProducts.includes(currentRow.product) }
  })
}

const getUsedProductFamiliesMap = (rows: GridValidRowModel[], groupBy: "product" | "family") => {
  const valueField = groupBy === "product" ? "family" : "product"

  return rows.reduce<Record<string, string[]>>((result, row) => {
    if (!result[row[groupBy]]) result[row[groupBy]] = []
    // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
    if (!result[row[groupBy]].includes(row[valueField])) result[row[groupBy]].push(row[valueField])

    return result
  }, {})
}
